<template>
  {{ props.item[props.column.key] }}
</template>

<script setup>
  
const props = defineProps({
  item: Object,
  column: Object
});

</script>